import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/community/topics')({
  component: Outlet,
})
